var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12.25a.75.75 0 01.75-.75h6.5a.75.75 0 010 1.5h-6.5a.75.75 0 01-.75-.75z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 11.5a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.037 1.25c-1.538 0-2.8.446-3.812 1.22-1 .766-1.713 1.82-2.219 2.98-1.005 2.302-1.256 5.154-1.256 7.46 0 1.104.408 1.997 1.096 2.606.673.597 1.557.87 2.44.87h.62l-2.262 5.278a.75.75 0 001.379.59L8.989 20h6.022l.966 2.255a.75.75 0 001.379-.591l-2.262-5.278h.62c.883 0 1.767-.273 2.44-.87.688-.609 1.096-1.502 1.096-2.607 0-2.3-.231-5.152-1.217-7.454-.496-1.16-1.198-2.216-2.193-2.983-1.005-.776-2.264-1.222-3.803-1.222zm-4.656 4.8C6.5 8.066 6.25 10.67 6.25 12.91c0 .712.251 1.183.59 1.483.353.312.861.493 1.446.493h7.428c.585 0 1.094-.18 1.446-.493.339-.3.59-.77.59-1.484 0-2.245-.233-4.848-1.096-6.864-.427-1-.995-1.818-1.73-2.386-.726-.56-1.658-.909-2.887-.909s-2.166.35-2.9.91c-.744.57-1.32 1.39-1.756 2.39zm6.081 10.336h-2.924L9.632 18.5h4.736l-.906-2.114z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/Chair.0d0c5811263294463c65ac581c87c926.svg";
export { ForwardRef as ReactComponent };